import _ from 'lodash';
import Box from '@mui/material/Box';
import TreeMapCustom from './TreeMapCustom';
import { CHART_TYPE } from './constants';
import TreeMapLabel from './TreeMapLabel';

// data:
// [
//   {
//     name: 'Main Group',
//     children: [
//       { name: 'Group A', size: 1000 }
//     ],
//   }
// ]

const COLORS = {
  "加入清單": '#e9a0a2',
  "查看商品": '#A9B7C4',
  "商品説明": '#5e9ff8',
  "其他推薦": '#8DC77B',
  "前往購買": '#E2CF45',
  "分享此圖": '#B4B5E0',
}

const Treemap = ({ chartType, chartData }) => {
  const treeMapData = chartData && Object.entries(chartData).map(el => ({
    "name": el[0],
    "size": parseInt(el[1])
  }))

  const formatData = [
    {
      name: 'engaged button',
      children: treeMapData
    }
  ]

  return (
    <>
      {
        chartType === CHART_TYPE.TREE_MAP_CUSTOM &&
        <Box>
          <TreeMapLabel
            chartData={formatData[0].children}
            colors={COLORS}
            label={"name"}
          />
          <TreeMapCustom
            chartData={formatData}
            colors={COLORS}
          />
        </Box>

      }
    </>
  );
};

export default Treemap;